<template>
  <slideout-panel v-on:slideout:close="closePanel" :open="updateProductPanelIsOpen" title="Update Product" >
    <div>
      <update-products-form  />
    </div>
  </slideout-panel>
</template>

<script>
import SlideoutPanel from "@/components/Functional/SlideoutPanel";
import UpdateProductsForm from "@/components/Products/UpdateProductsForm";

export default {
  name: "UpdateProductPanel",
  components: {UpdateProductsForm, SlideoutPanel},
  methods: {
    closePanel() {
      this.$store.dispatch('closeUpdateProductPanel')
    }
  },
  computed: {
    updateProductPanelIsOpen() {
      return this.$store.getters.getUpdateProductPanelIsOpen
    },
  },
}
</script>

<style scoped>

</style>
